<mat-card class="access-denied-card">
    <mat-card-header>
        <mat-card-title>{{ title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content style="text-align: center;">
        <p>As part of a recent permission model update, access to the <strong>{{ tabName }}</strong> tab now requires a specific role assignment.</p>
        <p><strong>Required role:</strong><br/>
            <code>{{ roleCode }}</code>: {{ roleDescription }}
        </p>
        <p>Remote Action settings can only be modified by authorized specialists to preserve system integrity.</p>
        <p>To request access, please contact the service desk or follow your organization's role access request process.</p>
    </mat-card-content>
</mat-card>
